export default {
  namespaced: true,

  state: {
    results: {
      primary: {
        size: null,
        confidence: 0,
      },
      secondary: {
        size: null,
        confidence: 0,
      },
    },
  },

  getters: {
    get: (state) => {
      return state.results;
    },
  },

  mutations: {
    set: (state, payload) => {
      state.results = payload;
    },
  },
};
